import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingRoomI18nUpdateMutation = graphql(/* GraphQL */ `
	mutation ExistingRoomI18nUpdate($input: RoomI18nInput!) {
		roomI18nUpdate(input: $input) {
			userErrors
			roomI18n {
				id
				lang
				hotelID
				roomID
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				name
				catchCopy
				description
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
			}
		}
	}
`);
